module.exports = __webpack_public_path__ + "static/media/slider_phone2.ec6c4a8e.png";